import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareChecklist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareChecklist"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM11.9396 7.55224L10.3396 6.35224L8.43554 8.89096L7.2656 8.111L6.1562 9.7751L8.90036 11.6045L11.9396 7.55224ZM13.0579 8V10H17.0579V8H13.0579ZM11.9396 13.5534L10.3396 12.3534L8.43554 14.8921L7.2656 14.1121L6.1562 15.7762L8.90036 17.6057L11.9396 13.5534ZM13 14V16H17V14H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareChecklist;
